import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    output,
    signal,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { DrawerComponent, IconComponent, SpinnerComponent } from '../../../../lib';
import { ProductsService } from '../../services';
import { GetProductsRequestPost, Product } from '../../common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { ProductFiltersComponent } from '../product-filters/product-filters.component';
import { ProductTileComponent } from '../product-tile/product-tile.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'ca-product-picker',
    templateUrl: './product-picker.component.html',
    styleUrl: './product-picker.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProductsService],
    imports: [
        MatButton,
        DrawerComponent,
        ProductFiltersComponent,
        SpinnerComponent,
        IconComponent,
        ProductTileComponent,
        MatIconButton,
        TranslatePipe
    ]
})
export class ProductPickerComponent {
    public languageCode = input.required<GetProductsRequestPost['languageCode']>();
    public countryCode = input.required<GetProductsRequestPost['countryCode']>();
    public buttonText = input<string>('PRODUCT_PICKER.BUTTON.SHOW_ALL');
    public headerText = input<string>('PRODUCT_PICKER.TITLE');
    public asCustomButton = input<boolean>(false);
    public productType = input<Product['productType']>();
    public allowedProductTypes = input<Product['productType'][]>();
    public productName = input<string>();
    public allowDifferentProductTypeSelection = input<boolean>(true);
    public selected = output<Product[]>();
    public selectedProductType = signal<Product['productType'] | undefined>(undefined);
    public productsService = inject(ProductsService);

    public selectedProducts: Product[] = [];

    @ViewChild('drawer', { static: true }) drawer!: DrawerComponent;
    @ViewChild('actionEl', { static: true }) actionEl!: TemplateRef<any>;
    @ViewChild('productImageEl', { static: true }) productImageEl!: TemplateRef<any>;
    @ViewChild('dataCellElement', { static: true }) dataCellElement!: TemplateRef<any>;

    setLocale = effect(() => {
        this.productsService.setLocale(this.languageCode(), this.countryCode());
    });

    readProducts(): void {
        this.productsService.readProducts();
    }

    onDrawerVisibleChange(): void {
        this.productsService.cancelPending();
    }

    onFilter(filters: { productName: string; productType: Product['productType'] }): void {
        this.selectedProductType.set(filters.productType);
        this.productsService.setKeyword(filters.productName);
        this.productsService.setProductType(filters.productType);
        this.productsService.readProducts();
    }

    onProductSelect(product: Product): void {
        const isSelected = this.selectedProducts.find(p => p.id === product.id);
        if (isSelected) {
            this.selectedProducts = this.selectedProducts.filter(p => p.id !== product.id);
            return;
        }
        this.selectedProducts = [product];
    }

    close(): void {
        this.drawer.close();
    }

    confirm(): void {
        this.selected.emit(this.selectedProducts);
        this.drawer.close();
    }
}
